import classNames from "classnames";

export interface IAvatar {
  src?: string;
  initials: string;
}

type AvatarProps = {
  avatar: IAvatar;
  className?: string;
};

export function Avatar({
  avatar,
  className = "border-th-primary-900 bg-th-primary-900",
}: AvatarProps) {
  return (
    <div
      title={avatar.initials}
      className={classNames(
        "relative h-12 w-12 overflow-hidden rounded-full border text-xl font-bold text-white",
        className,
      )}
    >
      {avatar.src ? (
        <img
          src={avatar.src}
          alt="Avatar Bild"
          className="h-full w-full object-cover"
        />
      ) : (
        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
          {avatar.initials}
        </span>
      )}
    </div>
  );
}
